import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { forkJoin } from 'rxjs';
import { Estado } from 'src/app/models/estado.interface';
import { Hospital } from 'src/app/models/hospital.interface';
import { Institucion } from 'src/app/models/institucion.interface';
import { AdministradorService } from 'src/app/services/administrador.service';
@Component({
  selector: 'app-administrador-hospital-nuevo',
  templateUrl: './administrador-hospital-nuevo.component.html',
  styleUrls: ['./administrador-hospital-nuevo.component.scss'],
  providers: [MessageService]
})
export class AdministradorHospitalNuevoComponent  {
      hospitalForm: FormGroup;
      estados: Estado[] = [];
      instituciones: Institucion[] = [];

      constructor(
        private fb: FormBuilder,
        private messageService: MessageService,
        private administradorService: AdministradorService){
        
        this.hospitalForm = this.crearFormulario();
        this.obtenerInformacion();

      }
    
      obtenerInformacion(): void { this.cargarDatos();}
      
      cargarDatos(): void {
    
      forkJoin({      
          subEstados: this.administradorService.getCatalogoEstados(),
          subInstituciones: this.administradorService.getCatalogoInstituciones()    
        }).subscribe({
          next:(resp)=> {        
              this.fullCatalogoInstituciones(resp.subInstituciones);
              this.fullCatalogoEstados(resp.subEstados);       
          },
          error:(err)=> { console.log(err) }
        });
    
      }

      fullCatalogoInstituciones(instituciones: Institucion[]): void {   
        this.instituciones.push(...instituciones);
      }
    
      fullCatalogoEstados(estados: Estado[]): void {
       this.estados.push(...estados);
      }

      onSubmit(): void {
        if (this.hospitalForm.valid) {
          const estado: Estado = this.hospitalForm.value.fk_estado;
          const institucion: Institucion = this.hospitalForm.value.fk_institucion;
          const {nomHospital, direccion, telefono} = this.hospitalForm.value;
          let hospital: Hospital = { nomHospital, direccion, telefono, fk_estado: estado.id, fk_institucion: institucion.id };
        //  console.log('Formulario enviado:', this.hospitalForm.value);
          this.administradorService
          .setHospital(hospital)
          .subscribe({
            next:(resp)=> {
             
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail:  resp.mensaje
              });
              this.resetForm();
            },
            error:(err: HttpErrorResponse)=> {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: err.error.message
              });
              this.markFormGroupTouched(this.hospitalForm);
            }
          })
         
        } else {
          
        }
      }
    
      crearFormulario(): FormGroup {
        return this.fb.group({
          nomHospital: ['', [Validators.required, Validators.minLength(3)]],
          fk_institucion: ['', [Validators.required]],
          fk_estado: ['', Validators.required],
          direccion:  [''],
          telefono: [''],
        });
      }
    
      private markFormGroupTouched(formGroup: FormGroup): void {
        Object.values(formGroup.controls).forEach(control => {
          control.markAsTouched();
        });
      }
        
      get f() {
        return this.hospitalForm.controls;
      }
      resetForm(): void {
        this.hospitalForm.reset();
      }
}
